module.exports = "/_next/static/images/5fa2ca71800a2e57d9917588639765c7-people-smile-at-home-xs@1x.jpg.webp";